import React, { useEffect, useState } from "react";

// Centered spinner shown by the route guards while the auth check is in
// flight. If the wait drags on (a Cloud Run cold start can take 15-30s), a
// short reassurance appears so the delay reads as "waking up" rather than
// "broken" — an unexplained spinner is what makes visitors give up.
const SLOW_MESSAGE_DELAY_MS = 4000;

export default function AuthLoadingScreen() {
  const [showSlowMessage, setShowSlowMessage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(
      () => setShowSlowMessage(true),
      SLOW_MESSAGE_DELAY_MS
    );
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center h-screen gap-4"
      role="status"
      aria-label="Loading"
    >
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-gray-900"></div>
      {showSlowMessage && (
        <p className="text-sm text-gray-500 text-center px-6">
          Waking up our secure servers — this first load can take a few extra
          seconds.
        </p>
      )}
    </div>
  );
}
